/** Default editor height — shared between the Suspense fallback and the impl. */
export const DEFAULT_HEIGHT = '200px';

/** Background colors for each theme — used by the Suspense fallback. */
export const THEME_BACKGROUNDS = {
  light: '#fafafa',
  dark: '#242651',
} as const;

/**
 * Monaco's default line height at our font size. Used only where the real
 * value isn't available yet — the Suspense fallback, and the first render
 * before the editor reports its own.
 */
export const FALLBACK_LINE_HEIGHT = 18;

/**
 * The editor's own vertical padding. Monaco's `getContentHeight` already
 * includes it, so anything sizing a box to hold a number of lines adds it too.
 */
export const EDITOR_PADDING = { top: 12, bottom: 12 } as const;

/** The height, in px, of a box holding `lines` lines plus the editor padding. */
export function linesToHeight(lines: number, lineHeight: number): number {
  return lines * lineHeight + EDITOR_PADDING.top + EDITOR_PADDING.bottom;
}
